import React, { useState, useEffect } from "react"
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined"
import "src/styles/scroll.scss"
import { Box } from "@mui/material"
import { Typography } from "src/UILibrary"

const ScrollToTop = () => {
  const [showTopBtn, setShowTopBtn] = useState(false)
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        setShowTopBtn(true)
      } else {
        setShowTopBtn(false)
      }
    })
  }, [])
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }
  return (
    <>
      {showTopBtn && (
        <Box
          className="top-to-btm icon-position icon-style"
          sx={{ textAlign: "center" }}
          onClick={goToTop}
        >
          <KeyboardArrowUpOutlinedIcon width={"100px"} className="" />
          <Typography.Caption>{"TOP"}</Typography.Caption>
        </Box>
      )}
    </>
  )
}
export default ScrollToTop
